/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendActualSaleDto } from '../models/backend-actual-sale-dto';
import { monitoringFactBalanceRetrieve } from '../fn/monitoring-fact-reports/monitoring-fact-balance-retrieve';
import { MonitoringFactBalanceRetrieve$Params } from '../fn/monitoring-fact-reports/monitoring-fact-balance-retrieve';
import { monitoringFactCashFlowRetrieve } from '../fn/monitoring-fact-reports/monitoring-fact-cash-flow-retrieve';
import { MonitoringFactCashFlowRetrieve$Params } from '../fn/monitoring-fact-reports/monitoring-fact-cash-flow-retrieve';
import { monitoringFactCoefficientsRetrieve } from '../fn/monitoring-fact-reports/monitoring-fact-coefficients-retrieve';
import { MonitoringFactCoefficientsRetrieve$Params } from '../fn/monitoring-fact-reports/monitoring-fact-coefficients-retrieve';
import { monitoringFactProfitLossRetrieve } from '../fn/monitoring-fact-reports/monitoring-fact-profit-loss-retrieve';
import { MonitoringFactProfitLossRetrieve$Params } from '../fn/monitoring-fact-reports/monitoring-fact-profit-loss-retrieve';
import { monitoringFactSalesList } from '../fn/monitoring-fact-reports/monitoring-fact-sales-list';
import { MonitoringFactSalesList$Params } from '../fn/monitoring-fact-reports/monitoring-fact-sales-list';

@Injectable({ providedIn: 'root' })
export class BackendApiMonitoringFactReportsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `monitoringFactBalanceRetrieve()` */
  static readonly MonitoringFactBalanceRetrievePath = '/api/monitoring/fact/balance/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringFactBalanceRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFactBalanceRetrieve$Response(
    params: MonitoringFactBalanceRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringFactBalanceRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringFactBalanceRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFactBalanceRetrieve(params: MonitoringFactBalanceRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.monitoringFactBalanceRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringFactCashFlowRetrieve()` */
  static readonly MonitoringFactCashFlowRetrievePath = '/api/monitoring/fact/cash-flow/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringFactCashFlowRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFactCashFlowRetrieve$Response(
    params: MonitoringFactCashFlowRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringFactCashFlowRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringFactCashFlowRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFactCashFlowRetrieve(
    params: MonitoringFactCashFlowRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringFactCashFlowRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringFactCoefficientsRetrieve()` */
  static readonly MonitoringFactCoefficientsRetrievePath = '/api/monitoring/fact/coefficients/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringFactCoefficientsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFactCoefficientsRetrieve$Response(
    params: MonitoringFactCoefficientsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringFactCoefficientsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringFactCoefficientsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFactCoefficientsRetrieve(
    params: MonitoringFactCoefficientsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringFactCoefficientsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringFactProfitLossRetrieve()` */
  static readonly MonitoringFactProfitLossRetrievePath = '/api/monitoring/fact/profit-loss/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringFactProfitLossRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFactProfitLossRetrieve$Response(
    params: MonitoringFactProfitLossRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringFactProfitLossRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringFactProfitLossRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFactProfitLossRetrieve(
    params: MonitoringFactProfitLossRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringFactProfitLossRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringFactSalesList()` */
  static readonly MonitoringFactSalesListPath = '/api/monitoring/fact/sales/{scenario_id}/';

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringFactSalesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFactSalesList$Response(
    params: MonitoringFactSalesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualSaleDto>>> {
    return monitoringFactSalesList(this.http, this.rootUrl, params, context);
  }

  /**
   * RBAC резолвер project через Scenario для views, у которых URL kwarg —
   * Scenario.pk (а не Project.pk). Принимает `scenario_id`, `scenario_pk` или
   * `pk` (в этом порядке).
   *
   * Виды usage:
   *     class MyView(ScenarioRBACMixin, APIView):
   *         section = ProjectSection.MONITORING
   *
   * Подключается к HasProjectSectionPermission через метод
   * `resolve_rbac_project(request)` (см. access/permissions.py, step 0).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringFactSalesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringFactSalesList(
    params: MonitoringFactSalesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualSaleDto>> {
    return this.monitoringFactSalesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendActualSaleDto>>): Array<BackendActualSaleDto> => r.body),
    );
  }
}
